"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShakaPlayer = void 0;
var player_base_1 = require("@24i/player-base");
var player_html5_1 = require("@24i/player-html5");
var shaka_player_1 = __importDefault(require("shaka-player"));
var package_json_1 = require("shaka-player/package.json");
var mux_js_1 = __importDefault(require("mux.js"));
var player_utils_1 = require("@24i/player-utils");
var helpers_1 = require("../helpers");
var support_1 = require("../support");
window.muxjs = mux_js_1.default;
var ShakaPlayer = (function (_super) {
    __extends(ShakaPlayer, _super);
    function ShakaPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supportedFormats = ShakaPlayer.SupportedFormats;
        _this.initialDVRWindowSize = null;
        _this.initialStartPositionInMs = null;
        _this.isPlayingHlsNatively = false;
        _this.nativeSeekableStart = NaN;
        _this.nativeSeekableEnd = NaN;
        _this.nativeSeekableSnapshotAt = NaN;
        _this.nativeSeekableSegment = NaN;
        _this.nativeSeekableConstantStart = false;
        _this.bitrate = 0;
        _this.requestedVideoTrack = null;
        _this.requestedAudioTrack = null;
        _this.requestedTextTrack = null;
        _this.isAutomaticModeEnabled = true;
        _this.externalTextTracks = [];
        _this.requestHooks = [];
        _this.responseHooks = [_this.mimeStreamResponseHook.bind(_this)];
        _this.onShakaLoaded = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.initialStartPositionInMs = player_utils_1.secondsToMilliseconds(this.shakaPlayer.seekRange().start);
                        this.isPlayingHlsNatively = Boolean(!this.manifest &&
                            this.mediaElement.src &&
                            this.source.mimeType === player_base_1.MIME_TYPE.HLS);
                        return [4, this.loadTextTracks()];
                    case 1:
                        _a.sent();
                        this.imageTracks = this.getImageTracks();
                        this.invalidateTracks();
                        return [2];
                }
            });
        }); };
        _this.onShakaTextTrackChanged = function () {
            _this.invalidateTracks();
            _this.triggerEvent('texttrackchanged', {
                track: _this.selectedTextTrack,
            });
        };
        _this.onShakaTracksChanged = function () {
            _this.invalidateTracks();
            _this.applyVideoTrack();
            _this.applyAudioTrack();
            _this.applyTextTrack();
        };
        _this.onShakaAudioTrackChanged = function () {
            _this.invalidateTracks();
            _this.triggerEvent('audiotrackchanged', {
                track: _this.selectedAudioTrack,
            });
        };
        _this.onShakaVideoTrackChanged = function () {
            _this.invalidateTracks();
            _this.triggerEvent('videotrackchanged', {
                track: _this.selectedVideoTrack,
            });
        };
        _this.onShakaBitrateChanged = function () {
            _this.invalidateTracks();
            var tracks = _this.shakaPlayer.getVariantTracks();
            var currentBitrate;
            tracks.forEach(function (track) {
                if (track.active) {
                    currentBitrate = track.videoBandwidth;
                }
            });
            if (currentBitrate !== _this.bitrate) {
                _this.bitrate = currentBitrate;
                _this.triggerEvent('bitratechange', {
                    bitrate: currentBitrate,
                });
            }
        };
        _this.onShakaDashMetadata = function (event) {
            var _a;
            var detail = event.detail;
            var startTime = detail.startTime, schemeIdUri = detail.schemeIdUri, eventElement = detail.eventElement, value = detail.value;
            var messageData = (_a = eventElement.getAttribute('messageData')) !== null && _a !== void 0 ? _a : value;
            _this.triggerEvent('metadata', {
                type: schemeIdUri,
                value: messageData,
                time: startTime,
            });
        };
        _this.onShakaHlsMetadata = function (event) {
            var startTime = event.startTime;
            var payload = event.payload;
            _this.triggerEvent('metadata', {
                type: 'ID3',
                value: payload.data,
                time: startTime,
            });
        };
        _this.onShakaTimeUpdate = function () {
            _this.updateSeekableSnapshot();
            _this.updateMetrics();
        };
        _this.onShakaManifestParsed = function () {
            var _a;
            _this.manifest = _this.shakaPlayer.getManifest();
            var presentationTimeline = (_a = _this.manifest) === null || _a === void 0 ? void 0 : _a.presentationTimeline;
            if (presentationTimeline) {
                _this.initialStartPositionInMs = player_utils_1.secondsToMilliseconds(presentationTimeline.getSeekRangeStart());
                var resolvedStartPosition = _this.getStreamTime(_this.startPosition, _this.startPositionType);
                if (Number.isFinite(resolvedStartPosition)) {
                    var shakaStartTime = player_utils_1.millisecondsToSeconds(resolvedStartPosition + _this.initialStartPositionInMs);
                    _this.shakaPlayer.updateStartTime(shakaStartTime);
                }
            }
        };
        _this.onShakaErrorEvent = function (event) {
            var shakaError = event === null || event === void 0 ? void 0 : event.detail;
            if (!shakaError) {
                _this.onError(new player_base_1.PlayerError({
                    code: player_base_1.ErrorCodes.GENERAL_FAILURE,
                    message: 'unknown',
                }));
            }
            else if (!_this.shouldIgnoreError(shakaError)) {
                var error = _this.convertShakaError(shakaError);
                _this.onError(error);
            }
        };
        _this.licenseRequestHook = function (type, request) {
            var drm = (_this.source || {}).drm;
            if (type === shaka_player_1.default.net.NetworkingEngine.RequestType.LICENSE &&
                drm &&
                drm.httpRequestHeaders) {
                request.headers = drm.httpRequestHeaders;
            }
        };
        return _this;
    }
    ShakaPlayer.prototype.getPlayerName = function () {
        return ShakaPlayer.playerName;
    };
    ShakaPlayer.prototype.getVersion = function () {
        return ShakaPlayer.version;
    };
    ShakaPlayer.prototype.shouldIgnoreError = function (error) {
        return error.severity === shaka_player_1.default.util.Error.Severity.RECOVERABLE;
    };
    ShakaPlayer.prototype.convertShakaError = function (error) {
        var code = player_base_1.ErrorCodes.PLAYER_FAILURE;
        var message = error.message;
        var errorCode = error.code;
        var nativeCode;
        if (errorCode) {
            nativeCode = ShakaPlayer.getErrorCodeName(errorCode);
        }
        if ([
            shaka_player_1.default.util.Error.Code.BAD_HTTP_STATUS,
            shaka_player_1.default.util.Error.Code.HTTP_ERROR,
        ].includes(errorCode)) {
            code = player_base_1.ErrorCodes.PLAYER_SOURCE_UNAVAILABLE;
        }
        else if (error.category === shaka_player_1.default.util.Error.Category.NETWORK &&
            navigator.onLine === false) {
            code = player_base_1.ErrorCodes.NETWORK_FAILURE;
        }
        return new player_base_1.PlayerError({
            code: code,
            message: message,
            nativeCode: nativeCode,
            engine: ShakaPlayer.playerName,
            engineVersion: ShakaPlayer.version,
            source: this.sourceConfigurationObject,
        });
    };
    ShakaPlayer.prototype.bindEventListeners = function () {
        if (!this.shakaPlayer)
            return;
        this.shakaPlayer.addEventListener('error', this.onShakaErrorEvent);
        this.shakaPlayer.addEventListener('loaded', this.onShakaLoaded);
        this.shakaPlayer.addEventListener('trackschanged', this.onShakaTracksChanged);
        this.shakaPlayer.addEventListener('trackschanged', this.onShakaAudioTrackChanged);
        this.shakaPlayer.addEventListener('trackschanged', this.onShakaTextTrackChanged);
        this.shakaPlayer.addEventListener('variantchanged', this.onShakaAudioTrackChanged);
        this.shakaPlayer.addEventListener('variantchanged', this.onShakaVideoTrackChanged);
        this.shakaPlayer.addEventListener('textchanged', this.onShakaTextTrackChanged);
        this.shakaPlayer.addEventListener('texttrackvisibility', this.onShakaTextTrackChanged);
        this.shakaPlayer.addEventListener('adaptation', this.onShakaBitrateChanged);
        this.shakaPlayer.addEventListener('timelineregionenter', this.onShakaDashMetadata);
        this.shakaPlayer.addEventListener('metadata', this.onShakaHlsMetadata);
        this.shakaPlayer.addEventListener('manifestparsed', this.onShakaManifestParsed);
        this.mediaElement.addEventListener('timeupdate', this.onShakaTimeUpdate);
        _super.prototype.bindEventListeners.call(this);
    };
    ShakaPlayer.prototype.unbindEventListeners = function () {
        if (!this.shakaPlayer)
            return;
        this.shakaPlayer.removeEventListener('error', this.onShakaErrorEvent);
        this.shakaPlayer.removeEventListener('loaded', this.onShakaLoaded);
        this.shakaPlayer.removeEventListener('trackschanged', this.onShakaTracksChanged);
        this.shakaPlayer.removeEventListener('trackschanged', this.onShakaAudioTrackChanged);
        this.shakaPlayer.removeEventListener('trackschanged', this.onShakaTextTrackChanged);
        this.shakaPlayer.removeEventListener('variantchanged', this.onShakaAudioTrackChanged);
        this.shakaPlayer.removeEventListener('textchanged', this.onShakaTextTrackChanged);
        this.shakaPlayer.removeEventListener('texttrackvisibility', this.onShakaTextTrackChanged);
        this.shakaPlayer.removeEventListener('adaptation', this.onShakaBitrateChanged);
        this.shakaPlayer.removeEventListener('timelineregionenter', this.onShakaDashMetadata);
        this.shakaPlayer.removeEventListener('metadata', this.onShakaHlsMetadata);
        this.shakaPlayer.removeEventListener('manifestparsed', this.onShakaManifestParsed);
        this.mediaElement.removeEventListener('timeupdate', this.onShakaTimeUpdate);
        _super.prototype.unbindEventListeners.call(this);
    };
    ShakaPlayer.prototype.registerNetworkHooks = function () {
        var _this = this;
        this.shakaPlayer
            .getNetworkingEngine()
            .registerRequestFilter(function (type, request) {
            _this.requestHooks.forEach(function (requestHook) {
                requestHook(type, request);
            });
        });
        this.shakaPlayer
            .getNetworkingEngine()
            .registerResponseFilter(function (type, response) {
            _this.responseHooks.forEach(function (responseHook) {
                responseHook(type, response);
            });
        });
    };
    ShakaPlayer.prototype.initializePlayer = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var id, styles, styleSheet, customConfiguration;
            var _this = this;
            return __generator(this, function (_b) {
                shaka_player_1.default.polyfill.installAll();
                shaka_player_1.default.polyfill.PatchedMediaKeysApple.install();
                if (!shaka_player_1.default.Player.isBrowserSupported()) {
                    return [2, Promise.reject(new Error('ShakaPlayer is not supported in this browser.'))];
                }
                id = '24i_player_shaka-player';
                if (!document.getElementById(id)) {
                    styles = "\n            .shaka-text-container {\n                font-family: sans-serif;\n\n                pointer-events: none;\n\n                position: absolute;\n                left: 0;\n                bottom: 0;\n                width: 100%;\n                height: 100%;\n                min-width: 48px;\n\n                font-size: 20px;\n                line-height: 1.4;\n\n                color: rgb(255, 255, 255);\n            }\n\n            .shaka-text-container span {\n                background-color: rgba(0, 0, 0, 0.8);\n                color: rgb(255, 255, 255);\n                display: inline-block;\n            }\n\n            .shaka-text-container .shaka-nested-cue:not(:last-of-type):after {\n                content: \" \";\n                white-space: pre;\n            }\n\n            div:fullscreen .shaka-text-container {\n                font-size: 4.4vmin;\n            }\n            div:-webkit-full-screen .shaka-text-container {\n                font-size: 4.4vmin;\n            }\n            div:-moz-full-screen .shaka-text-container {\n                font-size: 4.4vmin;\n            }\n            div:-ms-fullscreen .shaka-text-container {\n                font-size: 4.4vmin;\n            }\n            ";
                    styleSheet = document.createElement('style');
                    styleSheet.id = '24i_player_shaka-player';
                    styleSheet.innerText = styles;
                    document.head.appendChild(styleSheet);
                }
                this.mediaElement.addEventListener('error', function (event) {
                    if (!_this.mediaElement.error) {
                        console.warn('[Player Shaka Player] Ignoring unexpected error event');
                        event.stopImmediatePropagation();
                    }
                });
                this.shakaPlayer = new shaka_player_1.default.Player();
                this.registerNetworkHooks();
                this.shakaPlayer.attach(this.mediaElement);
                this.shakaPlayer.setVideoContainer(this.parentElement);
                customConfiguration = (_a = this.initializationConfig) === null || _a === void 0 ? void 0 : _a.customConfiguration;
                if (customConfiguration) {
                    this.shakaPlayer.configure(customConfiguration);
                }
                return [2, _super.prototype.initializePlayer.call(this)];
            });
        });
    };
    ShakaPlayer.prototype.setDrmProtection = function (drm) {
        return __awaiter(this, void 0, void 0, function () {
            var drmConfig, fairplayDrmConfig, serverCertificate, initDataTransform;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4, _super.prototype.setDrmProtection.call(this, drm)];
                    case 1:
                        _c.sent();
                        fairplayDrmConfig = {};
                        if (!(drm && drm.packageName)) return [3, 3];
                        drmConfig = {
                            servers: (_a = {},
                                _a[drm.packageName] = drm.licenseServer,
                                _a),
                        };
                        if (drm.httpRequestHeaders)
                            this.requestHooks.push(this.licenseRequestHook);
                        if (!(drm.packageName.indexOf(player_base_1.DRM_TYPE.FAIRPLAY) > -1)) return [3, 3];
                        if (drm.packageName === player_base_1.DRM_TYPE.FAIRPLAY_1) {
                            try {
                                shaka_player_1.default.polyfill.PatchedMediaKeysApple.install();
                            }
                            catch (error) {
                                this.logger.warn('Unable to install PatchedMediaKeysApple', error);
                            }
                        }
                        return [4, this.setupFairplayLicense(drm)];
                    case 2:
                        serverCertificate = _c.sent();
                        initDataTransform = (drm === null || drm === void 0 ? void 0 : drm.contentId)
                            ? this.setupFairplayContentIDOverride(drm === null || drm === void 0 ? void 0 : drm.contentId)
                            : undefined;
                        fairplayDrmConfig = {
                            advanced: (_b = {},
                                _b[drm.packageName] = {
                                    serverCertificate: serverCertificate,
                                },
                                _b),
                            initDataTransform: initDataTransform,
                        };
                        _c.label = 3;
                    case 3:
                        if (this.shakaPlayer) {
                            this.shakaPlayer.configure({
                                drm: __assign(__assign({}, drmConfig), fairplayDrmConfig),
                            });
                        }
                        return [2];
                }
            });
        });
    };
    ShakaPlayer.prototype.setupFairplayLicense = function (drm) {
        return __awaiter(this, void 0, void 0, function () {
            var certificateUrl, certificate, finalCertificate, request, fetchedCertificate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        certificateUrl = drm.certificateUrl, certificate = drm.certificate;
                        finalCertificate = certificate;
                        if (!!certificate) return [3, 3];
                        return [4, fetch(certificateUrl)];
                    case 1:
                        request = _a.sent();
                        return [4, request.arrayBuffer()];
                    case 2:
                        fetchedCertificate = _a.sent();
                        finalCertificate = new Uint8Array(fetchedCertificate);
                        _a.label = 3;
                    case 3: return [2, Promise.resolve(finalCertificate)];
                }
            });
        });
    };
    ShakaPlayer.prototype.setupFairplayContentIDOverride = function (contentId) {
        var _this = this;
        return function (initData, initDataType) {
            if (initDataType !== 'skd')
                return initData;
            return shaka_player_1.default.util.FairPlayUtils.initDataTransform(initData, contentId ||
                shaka_player_1.default.util.FairPlayUtils.defaultGetContentId(initData), _this.shakaPlayer.drmInfo().serverCertificate);
        };
    };
    ShakaPlayer.prototype.getThumbnailByTime = function (timeInMs) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var time, finalTrack, thumbnails, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.imageTracks) === null || _a === void 0 ? void 0 : _a.length))
                            return [2, null];
                        time = timeInMs / 1000;
                        finalTrack = this.imageTracks.sort(function (a, b) { return b.height - a.height; })[0];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, this.shakaPlayer.getThumbnails(finalTrack.id, time)];
                    case 2:
                        thumbnails = _b.sent();
                        return [2, thumbnails];
                    case 3:
                        error_1 = _b.sent();
                        return [2, Promise.reject(error_1)];
                    case 4: return [2];
                }
            });
        });
    };
    ShakaPlayer.prototype.getThumbnails = function (timesInMs) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var items, i, timeValueToRewind, time, thumbnail, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.imageTracks) === null || _a === void 0 ? void 0 : _a.length)) {
                            return [2, _super.prototype.getThumbnails.call(this, timesInMs)];
                        }
                        if (!timesInMs.length) return [3, 8];
                        items = [];
                        i = 0;
                        _b.label = 1;
                    case 1:
                        if (!(i < timesInMs.length)) return [3, 7];
                        timeValueToRewind = this.seekableRange.end - timesInMs[i];
                        time = this.live
                            ? new Date().getTime() - timeValueToRewind
                            : timesInMs[i];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4, this.getThumbnailByTime(time)];
                    case 3:
                        thumbnail = _b.sent();
                        if (thumbnail) {
                            items.push(helpers_1.mapToGenericThumbnail(thumbnail));
                        }
                        return [3, 5];
                    case 4:
                        e_1 = _b.sent();
                        console.error('Error trying to get Thumbnails: ', e_1);
                        return [3, 5];
                    case 5:
                        if (i === timesInMs.length - 1)
                            return [2, Promise.resolve(items)];
                        _b.label = 6;
                    case 6:
                        i++;
                        return [3, 1];
                    case 7: return [3, 9];
                    case 8: return [2, Promise.reject('Error: empty array')];
                    case 9: return [2, Promise.reject('Error')];
                }
            });
        });
    };
    ShakaPlayer.prototype.mediaLoad = function () {
        return __awaiter(this, void 0, void 0, function () {
            var shakaConfig, shakaRestrictions_1, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        shakaConfig = {
                            manifest: {
                                hls: { ignoreTextStreamFailures: true },
                                dash: { autoCorrectDrift: true },
                                availabilityWindowOverride: NaN,
                                segmentRelativeVttTiming: false,
                            },
                            streaming: {
                                alwaysStreamText: true,
                                ignoreTextStreamFailures: true,
                                startAtSegmentBoundary: false,
                            },
                            drm: {},
                            abr: { restrictions: {} },
                        };
                        if (!this.shakaPlayer) {
                            throw new Error('shakaPlayer is not initialized on mediaLoad');
                        }
                        this.initialStartPositionInMs = null;
                        this.isPlayingHlsNatively = false;
                        if (this.abrStrategy) {
                            this.configureAbrStrategy();
                        }
                        if (this.trackRestrictions &&
                            Object.keys(this.trackRestrictions).length) {
                            shakaRestrictions_1 = {
                                maxBandwidth: Infinity,
                                maxFrameRate: Infinity,
                                maxHeight: Infinity,
                                maxPixels: Infinity,
                                maxWidth: Infinity,
                                minBandwidth: 0,
                                minFrameRate: 0,
                                minHeight: 0,
                                minPixels: 0,
                                minWidth: 0,
                            };
                            Object.keys(this.trackRestrictions).forEach(function (prop) {
                                var configRestriction = _this.trackRestrictions[prop];
                                if (prop in shakaRestrictions_1 &&
                                    typeof configRestriction === 'number') {
                                    shakaRestrictions_1[prop] = configRestriction;
                                }
                            });
                            shakaConfig.abr.restrictions = shakaRestrictions_1;
                        }
                        if (this.source.mimeType === player_base_1.MIME_TYPE.HLS) {
                            shakaConfig.manifest.availabilityWindowOverride = Infinity;
                            shakaConfig.manifest.segmentRelativeVttTiming = true;
                        }
                        this.shakaPlayer.configure(shakaConfig);
                        this.applyPerformanceTweaks();
                        this.applyCustomConfiguration();
                        return [4, this.shakaPlayer.load(this.source.url, null, this.source.mimeType || undefined)];
                    case 1:
                        _a.sent();
                        this.variantTracks = this.getVariants();
                        return [3, 3];
                    case 2:
                        error_2 = _a.sent();
                        if (error_2.code === shaka_player_1.default.util.Error.Code.LOAD_INTERRUPTED) {
                            console.error('[WARNING] LOAD_INTERRUPTED - Error code:', error_2.code);
                        }
                        else if ('severity' in error_2) {
                            throw this.convertShakaError(error_2);
                        }
                        else {
                            throw error_2;
                        }
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    ShakaPlayer.prototype.applyCustomConfiguration = function () {
        var _a;
        var customConfiguration = (_a = this.initializationConfig) === null || _a === void 0 ? void 0 : _a.customConfiguration;
        if (customConfiguration)
            this.shakaPlayer.configure(customConfiguration);
    };
    ShakaPlayer.prototype.addTextTrack = function (textTrack) {
        this.externalTextTracks.push(textTrack);
    };
    ShakaPlayer.prototype.loadTextTracks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.externalTextTracks.length) {
                    this.externalTextTracks.forEach(function (texTrack) {
                        _this.shakaPlayer.addTextTrackAsync(texTrack.url, texTrack.language, texTrack.kind, texTrack.mimeType);
                    });
                }
                return [2];
            });
        });
    };
    Object.defineProperty(ShakaPlayer.prototype, "live", {
        get: function () {
            return this.shakaPlayer && this.shakaPlayer.isLive();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShakaPlayer.prototype, "currentTime", {
        get: function () {
            if (!this.mediaElement)
                return 0;
            if (this.adsManager.isPlayingClientSide)
                return this.adsManager.currentTime;
            if (this.initialStartPositionInMs === null)
                return 0;
            return Math.max(0, (player_utils_1.secondsToMilliseconds(this.mediaElement.currentTime) || 0) -
                this.initialStartPositionInMs);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShakaPlayer.prototype, "seekableRange", {
        get: function () {
            var seekableRange = this.getInternalSeekableRange();
            return {
                start: this.applySeekingRestriction(seekableRange.start),
                end: this.applySeekingRestriction(seekableRange.end),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShakaPlayer.prototype, "timeshiftRange", {
        get: function () {
            if (this.live) {
                return this.getInternalSeekableRange();
            }
            return {
                start: 0,
                end: 0,
            };
        },
        enumerable: false,
        configurable: true
    });
    ShakaPlayer.prototype.getInternalSeekableRange = function () {
        var _a;
        if (!this.shakaPlayer || this.initialStartPositionInMs === null)
            return { start: 0, end: 0 };
        var _b = this.shakaPlayer.seekRange(), start = _b.start, end = _b.end;
        var presentationTimeline = (_a = this.manifest) === null || _a === void 0 ? void 0 : _a.presentationTimeline;
        if (end === 0 && presentationTimeline) {
            start = presentationTimeline.getSeekRangeStart();
            end = presentationTimeline.getSeekRangeEnd();
        }
        var currentTime = this.mediaElement.currentTime;
        var startTime = start;
        var endTime = end;
        if (this.shakaPlayer.isLive()) {
            if (this.manifest) {
                var _c = this.shakaPlayer.getConfiguration().streaming, safeSeekOffset = _c.safeSeekOffset, bufferingGoal = _c.bufferingGoal, rebufferingGoal = _c.rebufferingGoal;
                var minBufferTime = this.manifest.minBufferTime;
                var startSeekOffset = safeSeekOffset +
                    Math.max(bufferingGoal, rebufferingGoal, minBufferTime);
                startTime =
                    presentationTimeline.getSafeSeekRangeStart(startSeekOffset);
                startTime = Math.min(startTime, endTime);
            }
            else if (this.isPlayingHlsNatively &&
                Number.isFinite(this.nativeSeekableSnapshotAt)) {
                if (Number.isFinite(this.nativeSeekableSegment)) {
                    var sinceSnapshot = player_utils_1.millisecondsToSeconds(Date.now() - this.nativeSeekableSnapshotAt);
                    if (!this.nativeSeekableConstantStart) {
                        startTime = startTime + sinceSnapshot;
                    }
                    endTime =
                        endTime - this.nativeSeekableSegment + sinceSnapshot;
                }
                endTime = Math.max(endTime, currentTime);
            }
        }
        if (this.source.mimeType === player_base_1.MIME_TYPE.HLS) {
            if (!this.initialDVRWindowSize) {
                this.initialDVRWindowSize = endTime - startTime;
            }
            if (this.initialDVRWindowSize &&
                endTime - startTime > this.initialDVRWindowSize) {
                startTime = endTime - this.initialDVRWindowSize;
            }
        }
        var seekableStart = player_utils_1.secondsToMilliseconds(startTime) - this.initialStartPositionInMs;
        var seekableEnd = player_utils_1.secondsToMilliseconds(endTime) - this.initialStartPositionInMs;
        return {
            start: seekableStart,
            end: seekableEnd,
        };
    };
    Object.defineProperty(ShakaPlayer.prototype, "bufferedRanges", {
        get: function () {
            var _this = this;
            if (this.adsManager.isPlayingClientSide)
                return [{ start: 0, end: 0 }];
            if (this.initialStartPositionInMs === null)
                return [{ start: 0, end: 0 }];
            return this.shakaPlayer
                .getBufferedInfo()
                .total.map(function (_a) {
                var start = _a.start, end = _a.end;
                return ({
                    start: player_utils_1.secondsToMilliseconds(start) -
                        _this.initialStartPositionInMs,
                    end: player_utils_1.secondsToMilliseconds(end) - _this.initialStartPositionInMs,
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShakaPlayer.prototype, "performanceTweaks", {
        get: function () {
            return this.performanceTweaksInternal;
        },
        set: function (performanceTweaks) {
            this.performanceTweaksInternal = performanceTweaks;
            if (this.initializationConfig)
                this.initializationConfig.performanceTweaks = performanceTweaks;
            this.applyPerformanceTweaks();
        },
        enumerable: false,
        configurable: true
    });
    ShakaPlayer.prototype.applyPerformanceTweaks = function () {
        var _a;
        if (!this.shakaPlayer)
            return;
        var performanceTweaks = this.performanceTweaks;
        var dash = {};
        var manifest = {};
        var streaming = {};
        if (typeof (performanceTweaks === null || performanceTweaks === void 0 ? void 0 : performanceTweaks.backwardBuffer) === 'number') {
            streaming.bufferBehind = player_utils_1.millisecondsToSeconds(performanceTweaks.backwardBuffer);
        }
        if ((_a = this.source) === null || _a === void 0 ? void 0 : _a.lowLatency) {
            streaming.lowLatencyMode = true;
            streaming.rebufferingGoal = 0.01;
            if (typeof (performanceTweaks === null || performanceTweaks === void 0 ? void 0 : performanceTweaks.liveDelay) === 'number') {
                streaming.bufferingGoal = player_utils_1.millisecondsToSeconds(performanceTweaks.liveDelay);
            }
        }
        else {
            streaming.lowLatencyMode = false;
            if (typeof (performanceTweaks === null || performanceTweaks === void 0 ? void 0 : performanceTweaks.restartBuffer) === 'number') {
                streaming.rebufferingGoal = player_utils_1.millisecondsToSeconds(performanceTweaks.restartBuffer);
                manifest.defaultPresentationDelay =
                    streaming.rebufferingGoal * 1.5;
                dash.ignoreMinBufferTime = true;
            }
            if (typeof (performanceTweaks === null || performanceTweaks === void 0 ? void 0 : performanceTweaks.aheadBuffer) === 'number') {
                streaming.bufferingGoal = player_utils_1.millisecondsToSeconds(performanceTweaks.aheadBuffer);
            }
        }
        this.shakaPlayer.configure({
            manifest: __assign(__assign({}, manifest), { dash: dash }),
            streaming: streaming,
        });
    };
    ShakaPlayer.prototype.getStreamTime = function (time, seekType) {
        var _a, _b, _c, _d;
        if (seekType === void 0) { seekType = player_base_1.SeekType.CONTENT_TIME; }
        var _e = this, live = _e.live, initialStartPositionInMs = _e.initialStartPositionInMs;
        if (live && initialStartPositionInMs === null)
            return NaN;
        var end = (_b = (_a = this.seekableRange) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : 0;
        var finalTime = time;
        if (seekType === player_base_1.SeekType.CONTENT_TIME) {
            finalTime = this.adsManager.getMediaTime(time);
        }
        if (seekType === player_base_1.SeekType.TIMESHIFT && live) {
            finalTime = time + end;
        }
        if (seekType === player_base_1.SeekType.UTC) {
            if (live) {
                var startDate = this.shakaPlayer.getPresentationStartTimeAsDate();
                if (startDate) {
                    finalTime =
                        time - startDate.getTime() - initialStartPositionInMs;
                }
                else {
                    finalTime = time - Date.now() + end;
                }
            }
            else {
                var programStart = ((_d = (_c = this.source) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.programStart) || 0;
                finalTime = time - programStart;
            }
        }
        return finalTime;
    };
    ShakaPlayer.prototype.mediaSeek = function (finalTime) {
        this.mediaElement.currentTime = player_utils_1.millisecondsToSeconds(finalTime + this.initialStartPositionInMs);
    };
    ShakaPlayer.prototype.getUTCTimestamp = function (value) {
        if (this.live && this.shakaPlayer) {
            if (typeof value !== 'number') {
                return this.shakaPlayer.getPlayheadTimeAsDate();
            }
            var startDate = this.shakaPlayer.getPresentationStartTimeAsDate();
            if (startDate) {
                return new Date(startDate.getTime() + value + this.initialStartPositionInMs);
            }
        }
        return _super.prototype.getUTCTimestamp.call(this, value);
    };
    ShakaPlayer.prototype.getVariants = function () {
        if (!this.shakaPlayer || !this.shakaPlayer.getVariantTracks)
            return [];
        this.variantTracks = this.shakaPlayer.getVariantTracks();
        return this.variantTracks;
    };
    ShakaPlayer.prototype.getImageTracks = function () {
        if (!this.shakaPlayer)
            return [];
        return this.shakaPlayer.getImageTracks();
    };
    Object.defineProperty(ShakaPlayer.prototype, "selectedVideoTrack", {
        get: function () {
            return this.videoTracks.find(function (track) { return track.selected; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShakaPlayer.prototype, "selectedAudioTrack", {
        get: function () {
            return this.audioTracks.find(function (track) { return track.selected; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShakaPlayer.prototype, "selectedTextTrack", {
        get: function () {
            return this.textTracks.find(function (track) { return track.selected; });
        },
        enumerable: false,
        configurable: true
    });
    ShakaPlayer.prototype.invalidateTracks = function () {
        this.cachedVideoTracks = undefined;
        this.cachedAudioTracks = undefined;
        this.cachedTextTracks = undefined;
    };
    Object.defineProperty(ShakaPlayer.prototype, "videoTracks", {
        get: function () {
            if (!this.cachedVideoTracks) {
                this.cachedVideoTracks = this.buildVideoTracks();
            }
            return this.cachedVideoTracks;
        },
        enumerable: false,
        configurable: true
    });
    ShakaPlayer.prototype.buildVideoTracks = function () {
        var _this = this;
        if (!this.shakaPlayer)
            return [];
        var quality = this.initializationConfig.quality;
        var filteredQualities = new Array();
        var videoOptions = new Array();
        var variantTracks = this.shakaPlayer.getVariantTracks();
        var activeTrack = variantTracks.find(function (track) { return track.active; });
        filteredQualities = variantTracks.filter(function (track) {
            var equal = variantTracks.find(function (t) {
                return track !== t &&
                    t.height === track.height &&
                    t.language === track.language;
            });
            var isSameLanguage = track.language === 'und' ||
                track.language === (activeTrack === null || activeTrack === void 0 ? void 0 : activeTrack.language);
            return (isSameLanguage &&
                (!equal ||
                    (equal &&
                        track.bandwidth >= equal.bandwidth &&
                        track.primary)));
        });
        filteredQualities
            .filter(function (track) {
            return track.height &&
                (!(quality === null || quality === void 0 ? void 0 : quality.maximumQuality) ||
                    track.height <= quality.maximumQuality);
        })
            .forEach(function (track) {
            var isInitialQty = !_this.wasVideoTrackSelected &&
                (quality === null || quality === void 0 ? void 0 : quality.startingQuality) &&
                quality.startingQuality === track.height;
            if (isInitialQty)
                _this.isAutomaticModeEnabled = false;
            if (!videoOptions.find(function (option) { return option.height === track.height; })) {
                videoOptions.push(__assign(__assign({}, helpers_1.mapToVideoTrack(track)), { selected: (!_this.isAutomaticModeEnabled && track.active) ||
                        isInitialQty }));
            }
        });
        if (videoOptions.length) {
            videoOptions = videoOptions.sort(function (a, b) { return b.height - a.height; });
            var noneSelected = !videoOptions.find(function (item) { return item.selected; });
            videoOptions.unshift(__assign(__assign({}, helpers_1.mapToVideoTrack(activeTrack)), { id: '-1', label: noneSelected && (activeTrack === null || activeTrack === void 0 ? void 0 : activeTrack.height)
                    ? "Auto (" + (activeTrack === null || activeTrack === void 0 ? void 0 : activeTrack.height) + "p)"
                    : 'Auto', selected: noneSelected }));
        }
        return videoOptions;
    };
    Object.defineProperty(ShakaPlayer.prototype, "audioTracks", {
        get: function () {
            if (!this.cachedAudioTracks) {
                this.cachedAudioTracks = this.buildAudioTracks();
            }
            return this.cachedAudioTracks;
        },
        enumerable: false,
        configurable: true
    });
    ShakaPlayer.prototype.buildAudioTracks = function () {
        if (!this.shakaPlayer)
            return [];
        var audioVariants = [];
        var alreadyExistingLanguages = [];
        var audioLanguagesAndRoles = this.shakaPlayer.getAudioLanguagesAndRoles();
        var variants = this.shakaPlayer.getVariantTracks();
        variants.forEach(function (variant) {
            var isAudioIdIncluded = audioVariants.find(function (includedVariant) {
                var _a;
                return includedVariant.id ===
                    ((_a = variant.audioId) !== null && _a !== void 0 ? _a : variant.id).toString();
            });
            var associatedAudioLanguageAndRole = audioLanguagesAndRoles.find(function (audioLanguageAndRole) { return audioLanguageAndRole.language === variant.language; }) || {};
            if (!isAudioIdIncluded) {
                var activeTrack = variants.filter(function (track) { return track.active; })[0];
                audioVariants.push(helpers_1.mapToAudioTrack(__assign(__assign({}, variant), associatedAudioLanguageAndRole), activeTrack));
            }
        });
        var filteredTracks = audioVariants.filter(function (track) {
            var audioLanguageChannel = "" + track.language + track.channels;
            var exists = alreadyExistingLanguages.includes(audioLanguageChannel);
            alreadyExistingLanguages.push(audioLanguageChannel);
            return !exists;
        });
        if (filteredTracks.length === 1) {
            var targetTrack = filteredTracks[0];
            var newTrack = __assign(__assign({}, targetTrack), { language: targetTrack.language === '' ||
                    targetTrack.language === 'und'
                    ? 'default'
                    : targetTrack.language });
            filteredTracks[0] = newTrack;
        }
        return filteredTracks;
    };
    Object.defineProperty(ShakaPlayer.prototype, "textTracks", {
        get: function () {
            if (!this.cachedTextTracks) {
                this.cachedTextTracks = this.buildTextTracks();
            }
            return this.cachedTextTracks;
        },
        enumerable: false,
        configurable: true
    });
    ShakaPlayer.prototype.buildTextTracks = function () {
        if (!this.shakaPlayer)
            return [];
        var shakaTextTracks = this.shakaPlayer.getTextTracks();
        if (shakaTextTracks.length) {
            var hasActiveTrack_1 = false;
            var isTextTrackVisible_1 = this.shakaPlayer.isTextTrackVisible();
            var textTracks = shakaTextTracks
                .filter(function (track) { return track.language || track.label; })
                .map(function (track) {
                if (track.active) {
                    hasActiveTrack_1 = true;
                }
                return __assign(__assign({}, helpers_1.mapToTextTrack(track)), { selected: isTextTrackVisible_1 && track.active });
            });
            return __spreadArray([
                this.getEmptyTextTrack(!hasActiveTrack_1 || !isTextTrackVisible_1)
            ], textTracks);
        }
        return _super.prototype.getTextTracks.call(this)
            .filter(function (textTrack) {
            return textTrack.label !== 'Shaka Player TextTrack';
        });
    };
    Object.defineProperty(ShakaPlayer.prototype, "audioTrack", {
        get: function () {
            return this.requestedAudioTrack;
        },
        set: function (audioTrack) {
            if (audioTrack === this.audioTrack)
                return;
            this.wasAudioTrackSelected = Boolean(audioTrack);
            this.requestedAudioTrack = audioTrack;
            this.invalidateTracks();
            this.applyAudioTrack();
        },
        enumerable: false,
        configurable: true
    });
    ShakaPlayer.prototype.applyAudioTrack = function () {
        var _this = this;
        var audioTrack = this.audioTrack;
        if (audioTrack) {
            var filter = function (candidateAudioTrack) {
                return helpers_1.kindFilter(candidateAudioTrack, audioTrack) &&
                    helpers_1.languageFilter(candidateAudioTrack, audioTrack) &&
                    helpers_1.channelFilter(candidateAudioTrack, audioTrack) &&
                    helpers_1.videoQualityFilter(candidateAudioTrack, _this.videoTrack);
            };
            var filteredVariants = this.shakaPlayer
                .getVariantTracks()
                .filter(filter);
            if (filteredVariants && filteredVariants.length === 1) {
                this.shakaPlayer.configure({
                    abr: { enabled: false },
                });
                this.shakaPlayer.selectVariantTrack(filteredVariants[0], true);
            }
            else {
                var kind = audioTrack.kind;
                if (kind === player_base_1.TrackKind.Undefined)
                    kind = undefined;
                this.shakaPlayer.selectAudioLanguage(audioTrack.language, kind);
            }
        }
    };
    Object.defineProperty(ShakaPlayer.prototype, "textTrack", {
        get: function () {
            return this.requestedTextTrack;
        },
        set: function (textTrack) {
            if (textTrack === this.textTrack)
                return;
            this.requestedTextTrack = textTrack;
            this.invalidateTracks();
            if (this.shakaPlayer && this.shakaPlayer.getTextTracks().length) {
                this.applyTextTrack();
            }
            else {
                _super.prototype.setTextTrack.call(this, textTrack);
            }
        },
        enumerable: false,
        configurable: true
    });
    ShakaPlayer.prototype.applyTextTrack = function () {
        var textTrack = this.textTrack;
        if (this.shakaPlayer && this.shakaPlayer.getTextTracks().length) {
            this.wasTextTrackSelected = Boolean(textTrack);
            var newVisibility = (textTrack === null || textTrack === void 0 ? void 0 : textTrack.id) !== player_base_1.EMPTY_TRACK_ID;
            this.shakaPlayer.setTextTrackVisibility(!newVisibility);
            this.shakaPlayer.setTextTrackVisibility(newVisibility);
            if (textTrack.id !== this.selectedTextTrack.id) {
                if (textTrack && (textTrack === null || textTrack === void 0 ? void 0 : textTrack.id) !== player_base_1.EMPTY_TRACK_ID) {
                    this.shakaPlayer.selectTextTrack(textTrack.extra);
                }
                else {
                    this.shakaPlayer.setTextTrackVisibility(false);
                }
                this.triggerEvent('texttrackchanged', {
                    track: this.selectedTextTrack,
                });
            }
        }
    };
    Object.defineProperty(ShakaPlayer.prototype, "videoTrack", {
        get: function () {
            return this.requestedVideoTrack;
        },
        set: function (videoTrack) {
            if (videoTrack === this.videoTrack)
                return;
            this.wasVideoTrackSelected = Boolean(videoTrack);
            this.requestedVideoTrack = videoTrack;
            this.invalidateTracks();
            this.applyVideoTrack();
        },
        enumerable: false,
        configurable: true
    });
    ShakaPlayer.prototype.applyVideoTrack = function () {
        var videoTrack = this.videoTrack;
        if (this.shakaPlayer) {
            this.isAutomaticModeEnabled = !videoTrack || videoTrack.id === '-1';
            this.shakaPlayer.configure({
                abr: { enabled: this.isAutomaticModeEnabled },
            });
            if (!this.isAutomaticModeEnabled && videoTrack) {
                var newVideoTrack = this.variantTracks.find(function (el) { return String(el.id) === videoTrack.id; });
                this.shakaPlayer.selectVariantTrack(newVideoTrack, true);
                this.variantTracks = this.getVariants();
            }
            this.triggerEvent('videotrackchanged', {
                track: this.selectedVideoTrack,
            });
        }
    };
    ShakaPlayer.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.isPlayingHlsNatively = false;
        if (this.shakaPlayer && this.shakaPlayer.destroy) {
            this.shakaPlayer.destroy();
            this.shakaPlayer = null;
        }
    };
    ShakaPlayer.prototype.unload = function () {
        _super.prototype.unload.call(this);
        this.initialDVRWindowSize = null;
        this.initialStartPositionInMs = null;
        this.externalTextTracks = [];
        this.isPlayingHlsNatively = false;
        this.clearShaka();
    };
    ShakaPlayer.prototype.clearShaka = function () {
        var promises = [];
        if (!this.shakaPlayer)
            return Promise.resolve();
        this.shakaPlayer.resetConfiguration();
        promises.push(this.shakaPlayer.unload);
        return Promise.all(promises);
    };
    ShakaPlayer.prototype.mimeStreamResponseHook = function (type, response) {
        if (type === shaka_player_1.default.net.NetworkingEngine.RequestType.MANIFEST &&
            this.source.mimeType) {
            response.headers['Content-Type'] = this.source.mimeType;
            response.headers['content-type'] = this.source.mimeType;
        }
    };
    ShakaPlayer.prototype.getMediaInfo = function () {
        return {
            playerVersion: ShakaPlayer.playerName + " v." + this.getVersion(),
            currentTime: this.currentTime,
            duration: this.duration,
        };
    };
    ShakaPlayer.prototype.updateSeekableSnapshot = function () {
        if (this.shakaPlayer && this.isPlayingHlsNatively && this.live) {
            var _a = this.shakaPlayer.seekRange(), nativeSeekableStart = _a.start, nativeSeekableEnd = _a.end;
            if (Number.isNaN(this.nativeSeekableSnapshotAt) ||
                nativeSeekableStart !== this.nativeSeekableStart ||
                nativeSeekableEnd !== this.nativeSeekableEnd) {
                this.nativeSeekableSegment =
                    Number.isNaN(this.nativeSeekableSnapshotAt) ||
                        Number.isNaN(nativeSeekableEnd)
                        ? 0
                        : nativeSeekableEnd - this.nativeSeekableEnd;
                this.nativeSeekableConstantStart =
                    nativeSeekableStart === this.nativeSeekableStart;
                this.nativeSeekableStart = nativeSeekableStart;
                this.nativeSeekableEnd = nativeSeekableEnd;
                this.nativeSeekableSnapshotAt = Date.now();
            }
        }
    };
    ShakaPlayer.prototype.updateMetrics = function () {
        if (!this.shakaPlayer)
            return;
        var metrics = this.metricsInternal;
        var stats = this.shakaPlayer.getStats();
        metrics.droppedFrames = stats.droppedFrames;
        metrics.liveLatency =
            player_utils_1.secondsToMilliseconds(stats.liveLatency) || undefined;
        metrics.bandwidthEstimate = stats.estimatedBandwidth || undefined;
    };
    ShakaPlayer.prototype.configureAbrStrategy = function () {
        if (this.shakaPlayer) {
            var enabled = {
                defaultBandwidthEstimate: player_base_1.ABR_BITRATES[this.abrStrategy],
                enabled: true,
            };
            var disabled = {
                enabled: false,
            };
            this.shakaPlayer.configure({
                abr: !this.isAutomaticModeEnabled ? disabled : enabled,
            });
        }
    };
    ShakaPlayer.getErrorCodeName = function (code) {
        var _a;
        return (_a = this.errorCodesMap.get(code)) !== null && _a !== void 0 ? _a : code.toString();
    };
    ShakaPlayer.playerName = 'shaka-player';
    ShakaPlayer.version = package_json_1.version;
    ShakaPlayer.SupportedFormats = new support_1.ShakaSupportedFormats();
    ShakaPlayer.errorCodesMap = new Map(Object.entries(shaka_player_1.default.util.Error.Code)
        .filter(function (entry) { return typeof entry[1] === 'number'; })
        .map(function (entry) { return [entry[1], entry[0]]; }));
    return ShakaPlayer;
}(player_html5_1.HTML5Video));
exports.ShakaPlayer = ShakaPlayer;
//# sourceMappingURL=index.js.map